import { render } from "./AddWin.vue?vue&type=template&id=178c410a"
import script from "./AddWin.vue?vue&type=script&lang=js"
export * from "./AddWin.vue?vue&type=script&lang=js"

import "./AddWin.vue?vue&type=style&index=0&id=178c410a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__